import { z } from 'zod';

/**
 * ErrorMap zod global en français (spec 01 §4).
 * Fallback sobre pour tous les schémas partagés ; les champs les plus fréquents
 * (email, mot de passe, pseudo…) portent leurs propres messages « panda fun »
 * directement dans les DTO — un message passé à `.min()/.email()/…` prime
 * toujours sur cette map.
 *
 * Appliqué à l'import du package (voir bas de fichier) : web ET api parlent
 * français, y compris les 422 du ZodValidationPipe.
 */
export const zodFrErrorMap: z.ZodErrorMap = (issue, _ctx) => {
  switch (issue.code) {
    case z.ZodIssueCode.invalid_type:
      if (issue.received === z.ZodParsedType.undefined || issue.received === z.ZodParsedType.null) {
        return { message: 'Ce champ est requis.' };
      }
      return { message: 'Type de valeur invalide.' };

    case z.ZodIssueCode.invalid_string:
      if (issue.validation === 'email') return { message: 'Adresse email invalide.' };
      if (issue.validation === 'url') return { message: 'URL invalide.' };
      if (issue.validation === 'uuid') return { message: 'Identifiant invalide.' };
      return { message: 'Format invalide.' };

    case z.ZodIssueCode.too_small: {
      const min = Number(issue.minimum);
      if (issue.type === 'string') {
        return { message: min <= 1 ? 'Ce champ est requis.' : `Au moins ${min} caractères.` };
      }
      if (issue.type === 'number') return { message: `Doit être supérieur ou égal à ${min}.` };
      if (issue.type === 'array') {
        return { message: `Au moins ${min} élément${min > 1 ? 's' : ''}.` };
      }
      return { message: 'Valeur trop petite.' };
    }

    case z.ZodIssueCode.too_big: {
      const max = Number(issue.maximum);
      if (issue.type === 'string') return { message: `Au plus ${max} caractères.` };
      if (issue.type === 'number') return { message: `Doit être inférieur ou égal à ${max}.` };
      if (issue.type === 'array') {
        return { message: `Au plus ${max} élément${max > 1 ? 's' : ''}.` };
      }
      return { message: 'Valeur trop grande.' };
    }

    case z.ZodIssueCode.invalid_enum_value:
    case z.ZodIssueCode.invalid_literal:
      return { message: 'Valeur non autorisée.' };

    case z.ZodIssueCode.unrecognized_keys:
      return { message: `Champs non reconnus : ${issue.keys.join(', ')}.` };

    default:
      return { message: 'Valeur invalide.' };
  }
};

// L'anglais par défaut de zod ne doit jamais atteindre un écran ni une réponse
// API — le simple import de @redpandev/shared active la map.
z.setErrorMap(zodFrErrorMap);
